import { render, staticRenderFns } from "./View.vue?vue&type=template&id=4f2e3e2f&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2e3e2f')) {
      api.createRecord('4f2e3e2f', component.options)
    } else {
      api.reload('4f2e3e2f', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=4f2e3e2f&", function () {
      api.rerender('4f2e3e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/documents/View.vue"
export default component.exports